export const TOAST_ERROR_MESSAGE_KEY = 'gig_page_perseus.ugc.something_went_wrong';

export const METRIC_COUNT_PATH = 'localization.ugc.translate.ajax_error';

export const ERROR_CONTEXT = 'Gig page ugc translation error';
